import React, { useState, useCallback, useEffect } from 'react';

import {
  Messages,
  Calendar,
  Clock,
  Notes,
  Reminders,
  Mail,
  AppStore,
  Videos,
  YouTube,
  Calculator,
  ITunes,
  Stocks,
  VoiceMemos,
  Weather
} from './icons';
import Alert from './Alert';

import Headline from './Headline';
import LockScreenHeader from './LockScreenHeader';
import Dock from './Dock';
import SlideToUnlock from './SlideToUnlock';

import S from './iPhone.module.css';

const MicSpan = () => (
  <>
    {Array.from({ length: 90 }).map((i, idx) => (
      <span key={idx} />
    ))}
  </>
);

const noOp = () => null;

const getSelectedColor = (asPath) => {
  // console.log(123, asPath);

  const hash = asPath.split('#')[1];
  return hash && (hash.length === 3 || hash.length === 6)
    ? { backgroundColor: `#${hash}` }
    : {};
};

const ICONS = [
  Messages,
  Calendar,
  Clock,
  Notes,
  Reminders,
  Mail,
  AppStore,
  Videos,
  YouTube,
  Calculator,
  ITunes,
  Stocks,
  VoiceMemos,
  Weather
];

interface Props {
  isLocked?: boolean;
  isOn?: boolean;
  selectedColor?: {
    backgroundColor?: string;
  };
}
type State = Props;

const defaultState: State = {
  isLocked: true,
  isOn: true,
  selectedColor: {}
};

const IPhone = (props: Props) => {
  const [state, setState] = useState({
    ...defaultState,
    ...props
    // selectedColor: getSelectedColor(router.asPath)
  });

  const { isLocked, isOn, selectedColor } = state;

  // console.log('>>>', selectedColor);

  const toggleOnOff = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isOn: !prevState.isOn,
      isLocked: prevState.isOn ? true : prevState.isLocked
    }));
  }, [setState]);

  const turnOn = useCallback(() => {
    setState((prevState) => ({ ...prevState, isOn: true }));
  }, [setState]);

  const handleUnlock = useCallback(() => {
    setState((prevState) => ({ ...prevState, isLocked: false }));
  }, [setState]);

  // const handleLock = useCallback(() => {
  //   setState((prevState) => ({ ...prevState, isLocked: true }));
  // }, [setState]);

  const homeButtonClickHandler = useCallback(() => {
    setState((prevState) => ({ ...prevState, isOn: true }));
  }, [setState]);

  useEffect(() => {
    const handleHashChange = () => {
      setState((prevState) => ({
        ...prevState,
        selectedColor: getSelectedColor(window.location.href)
      }));
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', handleHashChange);
    }

    handleHashChange();
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [setState]);

  return (
    <div className={S.root}>
      <div className={S.lightGradient} />
      <div className={S.powerButton} onClick={toggleOnOff} />
      <div className={S.voiceToogle} />
      <div className={S.voicePlus} />
      <div className={S.voiceMinus} />
      <div className={S.camera} />
      <div className={S.mic}>
        <MicSpan />
      </div>

      <div className={S.blackBg} style={selectedColor} />
      <div
        className={S.display}
        data-is-on={String(isOn)}
        onClick={!isOn ? turnOn : noOp}
      >
        <Alert isOn={isOn} />
        {isOn && (
          <>
            <Headline isLocked={isLocked} />
            <LockScreenHeader isLocked={isLocked} />
            <SlideToUnlock isLocked={isLocked} onUnlock={handleUnlock} />
            <Dock isLocked={isLocked} />
          </>
        )}
        <div
          className={S.screenIcons}
          data-is-on={isOn}
          data-is-locked={isLocked}
        >
          {ICONS.map((Component, idx) => (
            <div className={S.icon} key={idx}>
              <Component isLocked={isLocked} isOn={isOn} idx={idx} />
            </div>
          ))}
        </div>
      </div>
      <div className={S.home} onClick={homeButtonClickHandler}></div>
    </div>
  );
};

export default IPhone;
